'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeHubSelector = undefined;

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HUB_SALES = _Hubs2.default.HUB_SALES,
    HUB_SERVICE = _Hubs2.default.HUB_SERVICE,
    HUB_MARKETING = _Hubs2.default.HUB_MARKETING;
var activeHubSelector = exports.activeHubSelector = function activeHubSelector() {
  var pathname = window.location.pathname;
  var match = pathname.match(/(\/sales)|(\/service)|(\/marketing)/);
  if (!match) return null;
  if (match[1]) return HUB_SALES;
  if (match[2]) return HUB_SERVICE;
  if (match[3]) return HUB_MARKETING;
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ActiveHubSelectors.js
// module id = 186
// module chunks = 3 4